export default __webpack_public_path__ + "static/media/raya-bg.c838fcdf.png";